module.exports = "dist/videos/help/separator-top-on.mp4";